import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { history } from '../../../index'
import { withRouter } from 'react-router-dom'
import Common from 'services/common.js'

@connect(({ user }) => ({ user }))
class ACL extends React.PureComponent {
  UNSAFE_componentWillMount() {
    const {
      user: { role },
      redirect = false,
      defaultRedirect = '/auth/404',
      roles = [],
    } = this.props

    const authorized = roles.includes(role)
    // if user not equal needed role and if component is a page - make redirect to needed route
    if (!authorized && redirect && !window.location.toString().includes('/reportlink')) {
      const url = typeof redirect === 'boolean' ? defaultRedirect : redirect
      if (JSON.parse(localStorage.getItem('userPayload')).scope_id) {
        history.push(
          '/' +
            JSON.parse(localStorage.getItem('userPayload')).clusterId +
            '/' +
            JSON.parse(localStorage.getItem('userPayload')).scope_id +
            '/no-access/auth/no-access',
        )
      } else {
        history.push(
          '/' +
            JSON.parse(localStorage.getItem('userPayload')).clusterId +
            '/no-access/auth/no-access',
        )
      }
      Common.showNotifications(
        'error',
        <div>
          You have no rights to access this page.
          <br />
          Redirected to "{url}"
        </div>,
      )
      // history.push(url)
    }
  }

  render() {
    const {
      user: { role },
      children,
      roles = [],
    } = this.props
    const authorized = roles.includes(role)
    const AuthorizedChildren = () => {
      // if user not authorized return null to component
      if (!authorized) {
        return null
      }
      // if access is successful render children
      return <Fragment>{children}</Fragment>
    }

    return AuthorizedChildren()
  }
}

export default withRouter(ACL)
